/*
 * Show the signin modal and apply postponed promo after Login if an apple pay session
 *
 * Note: this is needed only on basket and checkout but needs to be on all ways of logging in on
 * those pages, thus its presence here as a universal decorator
 */
var showSignInModalWithPromoDecoration = function (
    resolve,
    reject,
    isNewUserFlow = false,
    analyticsData = {},
    source = ''
) {
    // Required on the method level bc/ of a circular dependency otherwise.
    const Actions = require('Actions');
    const storeLocal = require('Store');

    const decoratedResolve = function (data) {

        const applePaySession = storeLocal.getState().applePaySession;
        // TODO: Remove isActive ApplePay check when you need to enable it for any signIn
        if (applePaySession.isActive) {
            const promo = storeLocal.getState().promo;
            if (promo.afterLogin && promo.afterLogin.length) {
                const promoUtils = require('utils/Promos');
                promoUtils.applyPromo(...promo.afterLogin).then(() => {
                    resolve(data);
                });
            } else {
                resolve(data);
            }
        } else {
            resolve(data);
        }
    };

    storeLocal.dispatch(
        Actions.showSignInModal({
            isOpen: true,
            callback: decoratedResolve,
            isNewUserFlow,
            analyticsData,
            errback: reject,
            source
        })
    );
};

/**
 * Renders the sign-in / register overlay if needed.  then redirects/calls the desired function
 *
 * Note: only checks for signed in/recognized versus anonymous, does not differentiate between
 * signed in and recognized (API call return status will handle that accordingly)
 *
 * @param {String} redirect        *TODO* Optional: path to redirect,
 *                                  else redirected to same page or home
 * @param {object} objdata         *TODO* Optional: object for storing the temporary data required
 *                                  by functionality which needs
 *                                 to be performed after registration is done
 *                                 objdata format should be : {
 *                                      sActionType : 'Loves',
 *                                      oActionData : {}
 *                                 }
 **/
// TODO: support redirect, and objdata
var requireAuthentication = function (
    requiredForRecognized = false,
    isNewUserFlow,
    analyticsData,
    source
) {
    //const store = require('Store');
    const validateUserStatus = require('utils/User').validateUserStatus;

    return new Promise(function (resolve, reject) {
        validateUserStatus().then(user => {
            var profileStatus = user.profileStatus;

            if (profileStatus === 0 || (profileStatus === 2 && requiredForRecognized)) {
                showSignInModalWithPromoDecoration(
                    resolve,
                    reject,
                    isNewUserFlow,
                    analyticsData,
                    source
                );
            } else {
                resolve();
            }
        });
    });
};

// TODO THOMAS 17.4:
//  refactor various files that are using the above requireAuthentication function
//  so that those files use new decorator that calls this promise function
//  files include: ProductQuickLookMessage.c.js, AccountGreeting.c.js, InlineBasket.c.js,
//  ProductLove.c.js, RewardItem.c.js, PleaseSignIn.c.js
var requireRecognizedAuthentication = function () {
    const validateUserStatus = require('utils/User').validateUserStatus;

    return new Promise((resolve, reject) => {
        validateUserStatus().then(user => {
            var profileStatus = user.profileStatus;

            if (profileStatus === 0) {
                showSignInModalWithPromoDecoration(resolve, reject);
            } else {
                resolve();
            }
        });
    });
};

var requireLoggedInAuthentication = function () {
    const userUtils = require('utils/User');
    const ssiApi = require('services/api/ssi');

    return new Promise((resolve, reject) => {
        require.ensure([], function (require) {
            const { setupFingerprint } = require('services/Fingerprint');
            setupFingerprint((deviceFingerprint) => {
                userUtils.validateUserStatus().then(user => {
                    var profileStatus = user.profileStatus;

                    if (profileStatus === 0) {
                        showSignInModalWithPromoDecoration(resolve, reject);
                    } else if (profileStatus === 2) {
                        if (Sephora.configurationSettings.isOptInSSIMWebEnabled) {
                            ssiApi.autoLogin({ deviceFingerprint })
                                .then(() => resolve())
                                .catch(() => showSignInModalWithPromoDecoration(resolve, reject));
                        } else {
                            showSignInModalWithPromoDecoration(resolve, reject);
                        }
                    } else {
                        resolve();
                    }
                });
            });
        });
    });
};

const SIGN_IN_SOURCES = {
    ACCOUNT_GREETING: 'account-greeting',
    PAGE_LOAD: 'page-load'
};

module.exports = {
    requireAuthentication: requireAuthentication,
    showSignInModalWithPromoDecoration: showSignInModalWithPromoDecoration,
    requireRecognizedAuthentication: requireRecognizedAuthentication,
    requireLoggedInAuthentication: requireLoggedInAuthentication,
    SIGN_IN_SOURCES
};
